import { v4 as uuidv4 } from 'uuid';
import { StructuralLoadCase } from './AnalyticalTypes';

export interface LoadCombination {
    id: string;
    name: string;
    factors: { caseId: string; factor: number }[];
}

export class StructuralLoadManager {
    private cases: Map<string, StructuralLoadCase> = new Map();
    private combinations: Map<string, LoadCombination> = new Map();

    constructor() {
        // Default Cases
        this.createLoadCase('DL1', 'Dead Load', 'Dead');
        this.createLoadCase('LL1', 'Live Load', 'Live');
    }

    createLoadCase(code: string, name: string, nature: StructuralLoadCase['nature']): StructuralLoadCase {
        const id = uuidv4();
        const loadCase: StructuralLoadCase = { id, name, nature };
        this.cases.set(id, loadCase);
        return loadCase;
    }

    createCombination(name: string, factors: { caseId: string; factor: number }[]): LoadCombination {
        const id = uuidv4();
        const combo: LoadCombination = { id, name, factors };
        this.combinations.set(id, combo);
        return combo;
    }

    getLoadCases(): StructuralLoadCase[] {
        return Array.from(this.cases.values());
    }

    getCombinations(): LoadCombination[] {
        return Array.from(this.combinations.values());
    }
}
